import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  CircularProgress,
} from "@mui/material";
import { CardContent, Paper, Typography } from "@mui/material";
import ProjectContext from "../../context/project/ProjectContext";

const TableDetails = (props) => {
  const navigate = useNavigate();
  const [cardData, setCardData] = useState(props.cardArray);
  const [sortedProjectList, setSortedProjectList] = useState(props.cardArray);
  const [orderBy, setOrderBy] = React.useState("Name");
  const [order, setOrder] = React.useState("asc");

  const projectContext = useContext(ProjectContext);
  const { selectProject } = projectContext;

  const headerConfig = [
    { id: "Name", numeric: false, label: "Project Name" },
    { id: "ClientName", numeric: true, label: "Client Name" },
    { id: "NetSuiteID", numeric: true, label: "NS Project ID" },
    { id: "ProjectManager", numeric: true, label: "Project Lead" },
    { id: "LeadOffice", numeric: true, label: "Lead Office" },
    { id: "ClientPrimaryContact", numeric: true, label: "Client Contact Name" },
  ];

  function descendingComparator(a, b, orderBy) {
    // console.log("descendingComparator props", a, b, orderBy);
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const getComparator = (a, b, order, orderBy) => {
    // console.log("getComparator props", a, b, order, orderBy);
    return order === "desc"
      ? descendingComparator(a, b, orderBy)
      : -descendingComparator(a, b, orderBy);
  };

  let sortList = async (propsOrder, propsOrderBy, data) => {
    // console.log("sortList props", propsOrder, propsOrderBy, order, orderBy);

    let sortOrder = propsOrder ? propsOrder : order;
    let sortOrderBy = propsOrderBy ? propsOrderBy : orderBy;
    // console.log("sortList order", sortOrder, sortOrderBy);

    let dataList = data ? data : cardData;

    //Map new array with each ele as 2 vals [ele , index]
    const indexedList = dataList.map((ele, i) => [ele, i]);
    // console.log("sortList indexedList", JSON.stringify(indexedList));

    // sort array with custom function
    indexedList.sort((a, b) => {
      const order = getComparator(a[0], b[0], sortOrder, sortOrderBy);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    // console.log("sortList indexedList--> sorted", JSON.stringify(indexedList));

    //Map array ele and remove index
    let sortedList = indexedList.map((el) => {
      // console.log('sortedProjectList ort', el[0]);
      return el[0];
    });
    // console.log("sortList sortedList", sortedList);
    setSortedProjectList(sortedList);
  };

  const handleSort = (property) => (event) => {
    console.log("handleSort props", property, event);
    const isAsc = orderBy === property && order === "asc";
    console.log("handleSort isAsc", isAsc);
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    sortList(isAsc ? "desc" : "asc", property);
  };

  const showDetails = (e, item) => {
    console.log("showDetails props", item);
    e.preventDefault();
    if (selectProject) selectProject(item);
    navigate("/project/details/" + item.ID);
  };

  useEffect(() => {
    console.log("TableDetails props", props);
    if (props.cardArray && props.search !== null && props.search !== "") {
      const appsList = props.cardArray.filter(
        (item) =>
          (item.Name &&
            item.Name.toLowerCase().includes(props.search.toLowerCase())) ||
          (item.ID && item.ID === props.search)
      );
      // console.log("TableDetails props appsList", appsList);
      setCardData(appsList);
      sortList(null, null, appsList);
    } else {
      setCardData(props.cardArray);
      sortList(null, null, props.cardArray);
    }
  }, [props.cardArray, props.search]);

  return (
    <CardContent
      sx={{
        background: "white",
        borderRadius: 3,
        width: "100%",
        overflow: "scroll",
      }}
    >
      <TableContainer
        sx={{ padding: "30px", minHeight: "60vh" }}
        component={Paper}
      >
        <Table>
          <TableHead>
            <TableRow>
              {headerConfig.map((ele) => (
                <TableCell
                  key={ele.id}
                  //align={ele.numeric ? "right" : "left"}
                  style={{
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                  sortDirection={orderBy === ele.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === ele.id}
                    direction={orderBy === ele.id ? order : "asc"}
                    onClick={handleSort(ele.id)}
                  >
                    {ele.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!props.isLoading &&
              sortedProjectList.map((ele) => (
                <TableRow>
                  <TableCell>
                    <a href='' onClick={(e) => showDetails(e, ele)}>
                      {ele.Name}
                    </a>
                  </TableCell>
                  <TableCell>{ele.ClientName}</TableCell>
                  <TableCell>{ele.NetSuiteID}</TableCell>
                  <TableCell>{ele.ProjectManager}</TableCell>
                  <TableCell>{ele.LeadOffice}</TableCell>
                  <TableCell>{ele.ClientPrimaryContact}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        {props.isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              padding: "30px",
              color: "#366aaf",
            }}
          >
            <CircularProgress />
          </div>
        )}
      </TableContainer>
    </CardContent>
  );
};

export default TableDetails;
